import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-success-excel-modal',
  templateUrl: './success-excel-modal.component.html',
  styleUrls: ['./success-excel-modal.component.css'],
})
export class SuccessExcelModalComponent implements OnInit {
  isCoEListRoute: boolean = false;

  /**
   * This is the constructor for the SuccessExcelModalComponent.
   * It takes three parameters: a MatDialogRef, a MatDialog, and a Router.
   * The MatDialogRef is used to close the dialog.
   * The MatDialog is used to display the dialog.
   * The Router is used to detect if the current route is the 'coe-list' route.
   * @param dialogRefs The MatDialogRef for the dialog.
   * @param dialog The MatDialog for the dialog.
   * @param router The Router for the application.
   */
  constructor(
    public dialogRefs: MatDialogRef<SuccessExcelModalComponent>,
    public dialog: MatDialog,
    private router: Router
  ) {}

  /**
   * This lifecycle hook is called after the component is initialized.
   * It is used to detect if the current route is the 'coe-list' route.
   * If it is, the success dialog will be closed when the user clicks the 'Success' button.
   */
  ngOnInit(): void {
    // Check if the current route is the 'coe-list' route.
    // If it is, the success dialog will be closed when the user clicks the 'Success' button.
    this.isCoEListRoute = this.router.url.includes('coe-list');
  }

  /**
   * Closes the success dialog.
   * This function is called when the user clicks the 'Success' button.
   */
  Success(): void {
    // Close the dialog
    this.dialogRefs.close();
  }
}
